import React from 'react'
import '../Blog.css'
import BlogHero from '../BlogHero'
import blogData from '../Blog.json'

const BlogPage2 = () => {
     const blog = blogData.find(item => item.id === 2)

  if (!blog) return <p>Blog not found</p>
  return (
     <>
        <BlogHero/>
        <div className='backdiv'>
         <div className="blog-article">
        <h2 className="blog-main-head">{blog.title}</h2>
        <p className="blog_date">{blog.date}</p>
        <div className='blogpage_imgdiv'>
        <img src={blog.image} alt={blog.title} className="zweedo_img" />
        </div>
        <div className='blogpage-box'>
        <p className="blogpage-content">{blog.description}</p>
        </div>

        <h2 className='blogpage-head'>{blog.head1}</h2>
          <div className='blogpage-box'>
        <p className='blogpage-content'>{blog.content1}</p>
        </div>
        <h2 className='blogpage-head1'>{blog.head2}</h2>
        <div className='blogpage-box'>
          <ul className='blogpage-content'>
  {blog.list1?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
</div>

        <h2 className='blogpage-head1'>{blog.head3}</h2>
         <div className='blogpage-box'>
        <ul className='blogpage-content'>
  {blog.list2?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
</div>
        <h2 className='blogpage-head1'>{blog.head4}</h2>
        <div className='blogpage-box'>
        <ul className='blogpage-content'>
  {blog.list3?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
        </div>
        <h2 className='blogpage-head1'>{blog.head5}</h2>
          <div className='blogpage-box'>
        <ul className='blogpage-content'>
  {blog.list4?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
        </div>
          <h2 className='blogpage-head1'>{blog.head6}</h2>
            <div className='blogpage-box'>
        <ul className='blogpage-content'>
  {blog.list5?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
        </div>
        <h2 className='blogpage-head1'>{blog.head7}</h2>
          <div className='blogpage-box'>
         <ul className='blogpage-content'>
  {blog.list6?.map((item, index) => (
    <li 
      key={index} 
      dangerouslySetInnerHTML={{ __html: item }} 
    />
  ))}
</ul>
        </div>
          <h2 className='blogpage-head1'>{blog.head8}</h2>
          <div className='blogpage-box'>
       <ul className='blogpage-content'>
          {blog.list7?.map((item, index) => <li key={index}>{item}</li>)}
        </ul>
        </div>
          <h2 className='blogpage-head'>{blog.head9}</h2>
           <div className='blogpage-box'>
        <p className="blogpage-content">{blog.content2}</p>
        </div>
      </div>
</div>
    </>
  )
}

export default BlogPage2